const { default: Swiper, Navigation, Autoplay, Pagination } = require('swiper');
Swiper.use([Navigation, Autoplay, Pagination]);

Swiper.use([Navigation, Autoplay, Pagination]);

const openBtns = document.querySelectorAll('.popup-link');
const modal = document.querySelector('#popup-packages');

let swiperModal;

function initSwiperModal() {
  if (!swiperModal) {
    swiperModal = new Swiper('.modalSwiper', {
      direction: 'horizontal',
      loop: true,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: modal.querySelector('.swiper-button-next'),
        prevEl: modal.querySelector('.swiper-button-prev'),
      },
    });
  } else {
    swiperModal.update();
    swiperModal.updateSize();
    swiperModal.updateSlides();
  }
}

openBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    requestAnimationFrame(initSwiperModal);
  });
});